import React, { useContext, useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import { NavLink, useLocation } from 'react-router-dom';
import Select from "react-select";
import ToggleSwitch from '../../Components/ToggleSwitch';
import { NoRecords } from '../../Components/Shimmer';
import Swal from 'sweetalert2';
import { currentDateAndTime, decodeData, decodeUrl, encodeData } from '../../Constants/constants';
import CryptoJS from "crypto-js";
import { SubmitButton } from '../../Components/InputElements';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const StatutorySlabMaster = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions,setPermissions } = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedDataId = decodeUrl(encodedData);
    // console.log("decodedDataId Slab Master",parseInt(decodedDataId));
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    // console.log("decodedData Slab Master",decodedData);

    const query = useQuery();
    const [state, setState] = useState(query.get("state"));
    const [statutoryType, setStatutoryType] = useState(query.get("statutoryType"));
    const [rows, setRows] = useState([]);
    const [statesRows, setStatesRows] = useState([]);
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        total_records: "",
        total_pages: "",
        limit: 10,
    });
    const [filter, setFilter] = useState({
        checkStatutoryType: statutoryType || null,
        checkState: state || null,
    });
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [companyInfo, setCompanyInfo] = useState({
        company_location_shift_id: 0
    });
    const [loadingList, setLoadingList] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [clearAction, setClearAction] = useState(false);
    const [limitAction, setLimitAction] = useState(false);
    const [toggleButton, setToggleButton] = useState(false);
    const limitOptions = [10, 25, 50, 100, 200, 500];

    const statutorySlabOptions = [
        { value: "PT", label: "PT" },
        { value: "ER LWF", label: "ER LWF" },
        { value: "EE LWF", label: "EE LWF" },
    ];

    const getInfo = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetShiftInfo?company_location_shift_id=${companyInfo?.company_location_shift_id}`, { headers }).then((response) => {
            const { data, success, days } = response.data;
            if (success === true) {


            } else {

            }
        });
    }

    const getStateAndDesignation = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetPTAndLWFStateList`,
            { params:{
                page:1,
                limit:999
            },
            headers })
            .then((response) => {
                const { success,data } = response.data;
                console.log(response?.data);
                if (success === true) {
                    let rows1 = data?.map((val) => {
                        return { value: val?.pt_lwf_state_id, label: val?.pt_lwf_state_title }
                    });
                    setStatesRows(rows1);
                }
            });
    }

    useEffect(() => {
        getStateAndDesignation();
    }, [])

    const getList = async () => {
        const headers = apiHeaderJSON;
        console.log(pagination?.limit,
            pagination?.page,
            filter?.keyword,
            filter?.checkHeadType,)
        axios.get(`${apiURL}Payrolls/StatutorySlabsList`, {
            params: {
                limit: pagination?.limit,
                page: pagination?.page,
                statutoryType: filter?.checkStatutoryType,
                stateId: filter?.checkState,
            }, headers
        }).then((response) => {

            let data = response.data;
            console.log(response?.data);

            if (response.data.success === true) {

                setRows(data?.result?.data);
                setPagination({
                    ...pagination,
                    next: data?.result?.next,
                    prev: data?.result?.prev,
                    page: data?.result?.page,
                    total_records: data?.result?.total_records,
                    total_pages: data?.result?.total_pages,
                });

            } 
        setLoadingList(false);
        setLoadingFilter(false);
        }).catch(function (error) {
            setLoadingList(false);
            setLoadingFilter(false);
            console.log("error", error);
        });
    }

    useEffect(() => {
        setLoadingList(true);
        setFilter({
            ...filter,
            checkState: state || "",
            checkStatutoryType: statutoryType || "",
        });
        getList();
    }, []);

    useEffect(() => {
        if (clearAction) {
            getList();
            setClearAction(false);
        }
    }, [clearAction]);
    useEffect(() => {
        if (limitAction) {
            getList();
            setLimitAction(false);
        }
    }, [limitAction]);

    const handleLimitChange = (e) => {
        // console.log(e.target.value);
        setPagination(
            {
                ...pagination,
                limit: e.target.value,
                page: 1,
            });
        setLimitAction(true);
    };
    const handlePageChange = (e) => {
        // console.log(e.target.value);
        setPagination(
            {
                ...pagination,
                page: parseInt(e.target.value),
            });
        setLimitAction(true);
    };

    const handleToggleSwitch = (statutory_slab_id, toggleButton) => {
        let data = {
            statutory_slab_id: statutory_slab_id,
            activated: toggleButton ? 1 : 2,
            date: currentDateAndTime(),
        }
        const headers = apiHeaderJSON;
        setToggleButton(!toggleButton);
        // console.log(data);
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to change Slab status to ${toggleButton ? "On" : "Off"}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .post(`${apiURL}Payrolls/HandleStatutorySlabActivation`, data, {
                        headers,
                    })
                    .then((response) => {
                        const { success } = response.data;
                        // console.log("handleToggleSwitch ~ response =======>>>", response);
                        if (success === true) {
                            // setSuccessMsg(response.data.message);
                            setErrorMsg(false);
                            getList(false);
                        } else {
                            setSuccessMsg(false);
                            // setErrorMsg(response.data.message);
                        }
                    });
            }
        });
    }

    const handleInputSearch = (e) => {
        getList();
    }
    const handleClearAll = (e) => {
        setFilter({
            checkStatutoryType: "",
            checkState: null,
        });
        setState("");
        setStatutoryType("");
        const url = window.location.origin + `/StatutorySlabMaster?abs=${encodedData}`;
        window.history.replaceState(null, '', url);
        setClearAction(true);

    }

    const handleInputChange = (e) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value,
        });
    };

    const handleChange = (name, value) => {
        setFilter({ ...filter, [name]: value });
    }
    const handleChanged = (type) => {
        setPagination({
          ...pagination,
          page: parseInt(type.target.value),
        });
        setLimitAction(true);
    }
    const handleDelete = (company_location_shift_id) => {

    }
    const handlePrev = () => {
        // console.log(pagination?.prev)
        if (pagination?.prev === true) {
            console.log(pagination?.page - 1)
            setPagination({
                ...pagination,
                page: pagination?.page - 1,
            });
        }
        setLimitAction(true);
    }
    const handleNext = () => {
        // console.log(pagination?.next)
        if (pagination?.next === true) {
            // console.log(pagination?.page + 1)
            setPagination({
                ...pagination,
                page: pagination?.page + 1,
            });
        }
        setLimitAction(true);
    }

    const handleSubmit = () => {

    }
    const headOptions = [
        { value: "Fixed Component", label: "Fixed Component" },
        { value: "Earning", label: "Earning" },
        { value: "EE Statutory Deduction ", label: "EE Statutory Deduction " },
        { value: "ER Statutory Contribution ", label: "ER Statutory Contribution " },
        { value: "Other Earnings", label: "Other Earnings" },
        { value: "Other Deductions", label: "Other Deductions" },
    ];
    return (
        <>
        {!loadingList? (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Statutory Slab Master`} primary={`Home`} />
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Statutory Slab List</h4>
                                        { decodedData?.includes(2) && ( 
                                        <NavLink to={`/StatutorySlab?abs=${encodeData(decodedDataId)}${filter?.checkStatutoryType && filter?.checkState ? `?statutoryType=${filter?.checkStatutoryType}&state=${filter?.checkState}` : filter?.checkStatutoryType? `?statutoryType=${filter?.checkStatutoryType}`: filter?.checkState ? `?state=${filter?.checkState}` : "" }`} className="btn btn-success" > Add Statutory Slab </NavLink >)}
                                    </div>
                                    <div className="card-header">
                                        <div className="row">
                                            <div className='col-md-3 position-relative mb-5'>
                                                <div>
                                                    <label>Statutory Type</label>
                                                </div>
                                                <div style={{ zIndex: 10, width: "90%" }}className=" position-absolute">
                                                    <Select
                                                        options={statutorySlabOptions}
                                                        value={filter?.checkStatutoryType ? statutorySlabOptions.find(option => option.value == filter?.checkStatutoryType) : null}
                                                        onChange={(selectedOption) => handleChange('checkStatutoryType', selectedOption?.value)}
                                                        placeholder={`Select Statutory Type`}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-md-3 position-relative mb-5'>
                                                <div>
                                                    <label>State</label>
                                                </div>
                                                <div style={{ zIndex: 10, width: "90%" }}className=" position-absolute">
                                                    <Select
                                                        options={statesRows}
                                                        value={filter?.checkState ? statesRows.find(option => option.value == filter?.checkState) : null}
                                                        onChange={(selectedOption) => handleChange('checkState', selectedOption?.value)}
                                                        placeholder={`Select state`}
                                                    />
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='row'>
                                                    <div  className='col-md-6'>
                                                        <div>
                                                            <label className=' noWrap'>Apply Filter</label>
                                                        </div>
                                                        <SubmitButton onClick={(e)=>{ 
                                                                if(!loadingFilter){
                                                                    setLoadingFilter("1");
                                                                    handleInputSearch();
                                                                }
                                                            }}
                                                            loading={loadingFilter==="1"} otherClasses='w-100' disabled={!filter?.checkStatutoryType && !filter?.checkState} 
                                                            loadingMessage='Loading' buttonName={'Filter'} icon={'ri-filter-3-fill'} 
                                                            type='info' iconSide='left' />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div>
                                                            <label className=' noWrap'>Clear Filter</label>
                                                        </div>
                                                        <SubmitButton onClick={(e)=>{ 
                                                            if(!loadingFilter){
                                                                setLoadingFilter("2");
                                                                handleClearAll();
                                                            }
                                                        }}
                                                        loading={loadingFilter==="2"} otherClasses='w-100' disabled={!filter?.checkStatutoryType && !filter?.checkState} 
                                                        loadingMessage='Loading' buttonName={'Clear'} icon={'ri-database-2-line'} 
                                                        type='secondary' iconSide='left' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="">
                                        <div style={{ "maxHeight": "65vh", "overflowY": "auto" }}>
                                            <table id="example" className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative" style={{ width: "100%" }}>
                                                <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                                    <tr>
                                                        <th width={`5%`} className=' text-center'>Sr.No.</th>
                                                        <th width={`50%`}>Statutory Type</th>
                                                        <th width={`25%`}>Statutory State</th>
                                                        <th width={`10%`} className=' text-center'>Status</th>
                                                        { decodedData?.includes(3) && ( 
                                                        <th width={`10%`} className=' text-center'>Action</th>)}
                                                    </tr>
                                                </thead>
                                                {
                                                    !loadingList ?
                                                        rows?.length == 0 ?
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={12}>
                                                                        <NoRecords />
                                                                    </td>
                                                                </tr>
                                                            </tbody> :
                                                            <tbody>
                                                                {
                                                                    rows?.length > 0 && rows?.map((row, idx) => {
                                                                        return <tr key={row?.statutory_slab_id}>
                                                                            <td className=' text-center'>{idx + 1}</td>
                                                                            <td>{row?.statutory_type}</td>
                                                                            <td>{row?.state_title}</td>
                                                                            <td>
                                                                                <div className='d-flex justify-content-around'>
                                                                                    <ToggleSwitch isActive={row?.activated === 1 ? true : false} isExtFunc={true} onToggle={() => { handleToggleSwitch(row?.statutory_slab_id, row?.activated === 1 ? false : true) }} />
                                                                                </div>
                                                                            </td>
                                                                            { decodedData?.includes(3) && ( 
                                                                            <td>
                                                                                <div className='d-flex justify-content-around'>
                                                                                <NavLink to={`/StatutorySlab?abs=${encodeData(decodedDataId)}&id=${row.statutory_slab_id}${filter?.checkStatutoryType ? `&statutoryType=${filter?.checkStatutoryType}` : ''}${filter?.checkState ? `&state=${filter?.checkState}` : ""}`} type='button' className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </NavLink>

                                                                                {/* <button onClick={() => handleDelete(row.company_salary_head_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>
                                                                                <button onClick={() => setCompanyInfo({ company_salary_head_id: row.company_salary_head_id })} className="btn-icon btn btn-sm btn-outline-success" data-bs-toggle="modal" data-bs-target="#myModal"> <i className="ri-file-info-line"></i> </button> */}
                                                                                </div>
                                                                            </td>)}
                                                                        </tr>
                                                                    })
                                                                }
                                                            </tbody> :
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={12}>
                                                                    <div className="text-center mt-3">
                                                                        <span className="text-info"><i className="mdi mdi-loading mdi-spin fs-1 align-middle me-2" /> Loading.....</span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                }

                                                {/* <tfoot className='table-light sticky-bottom z-1'>
                                                    <tr>
                                                        <th colSpan={8} >
                                                            <div className="d-flex justify-content-between" >
                                                                <button disabled={!pagination?.prev} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                                <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    {
                                                                        <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                                                    }
                                                                </div>
                                                                <div className='col-md-2'>
                                                                    <select className="form-select" onChange={(e) => { handlePageChange(e) }}>
                                                                        {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                                                            <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <select
                                                                        className="form-select"
                                                                        onChange={handleLimitChange}
                                                                        value={pagination?.limit}
                                                                    >
                                                                        {limitOptions.map((option) => (
                                                                            <option key={option} value={option}>
                                                                                Limit {option}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <button disabled={!pagination?.next} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </tfoot> */}
                                            </table>
                                        </div>
                                        <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2">
                                                <button disabled={ !pagination?.prev }
                                                type="button"
                                                onClick={() => handlePrev()}
                                                className={`btn btn-warning btn-label waves-effect waves-light`}
                                                >
                                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                                                Previous
                                                </button>
                                                <div
                                                className="col-md-4"
                                                style={{ display: "flex", alignItems: "center" }}
                                                >
                                                {
                                                    <small>
                                                    Total Records: {pagination?.total_records} | Total
                                                    Pages: {pagination?.total_pages} | Current Page:{" "}
                                                    {pagination?.page}
                                                    </small>
                                                }
                                                </div>
                                                <div className="col-md-2">
                                                <select className="form-select" onChange={(e) => handleChanged(e)}>
                                                    {Array.from( { length: pagination?.total_pages }, (_, i) => (
                                                        <option selected={pagination?.page === i + 1} key={i} value={i + 1} >
                                                        Page {i + 1}
                                                        </option>
                                                    )
                                                    )}
                                                </select>
                                                </div>
                                                <div className="col-md-2">
                                                <select className="form-select" onChange={(e) => handleLimitChange(e)} value={pagination?.limit}
                                                >
                                                    {pagination?.total_records >= 1 && (
                                                    <option value={pagination?.total_records}>
                                                        All
                                                    </option>
                                                    )}
                                                    {limitOptions?.map((option) => (
                                                    <option key={option} value={option}>
                                                        Limit {option}
                                                    </option>
                                                    ))}
                                                </select>
                                                </div>
                                                <button
                                                disabled={ !pagination?.next}
                                                type="button"
                                                onClick={() => handleNext()}
                                                className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                >
                                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                                                Next
                                                </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         ) : (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "90vh" }}
            >
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
           </div>
        )}
        </>
    );
}

export default StatutorySlabMaster;

